export default __webpack_public_path__ + "static/media/stop_zing.05fd24c3.png";